import React, { useState, useEffect } from "react";
import { FaThLarge, FaGlobe } from "react-icons/fa";
import "../../styles/aisprawl/aisprawl.css";
import "../../styles/ProfilesManager.css";


const APP_ENDPOINTS = [
  {
    device_id: "dev-0001",
    device_name: "FIN-LT-0001",
    edr_source: "mde",
    apps: [
      {
        app: "ChatGPT",
        publisher: "OpenAI",
        bucket: "generative_ai_chatbot",
        confidence: 0.94,
        action: "monitor",
      },
      {
        app: "GitHub Copilot",
        publisher: "GitHub (Microsoft)",
        bucket: "ai_coding_assistant",
        confidence: 0.92,
        action: "monitor",
      },
    ],
  },
  {
    device_id: "dev-0002",
    device_name: "ENG-LT-0002",
    edr_source: "crowdstrike",
    apps: [
      {
        app: "GitHub Copilot",
        publisher: "GitHub (Microsoft)",
        bucket: "ai_coding_assistant",
        confidence: 0.95,
        action: "monitor",
      },
      {
        app: "Cursor",
        publisher: "Anysphere",
        bucket: "ai_coding_assistant",
        confidence: 0.9,
        action: "monitor",
      },
    ],
  },
  {
    device_id: "dev-0003",
    device_name: "HR-LT-0003",
    edr_source: "mde",
    apps: [
      {
        app: "Microsoft 365 Copilot",
        publisher: "Microsoft",
        bucket: "enterprise_ai_copilot",
        confidence: 0.88,
        action: "allow",
      },
    ],
  },
];

const IP_ENDPOINTS = [
  {
    "device_id": "dev-net-0001",
    "device_name": "ENG-LT-0101",
    "edr_source": "mde",
    "signal_type": "network_ioc_match",
    "summary": {
      "first_seen": "2026-02-18T09:12:41Z",
      "last_seen": "2026-02-19T17:26:03Z",
      "events": 34,
      "distinct_destinations": 3
    },
    "evidence": [
      {
        "timestamp": "2026-02-19T17:26:03Z",
        "initiating_process": {
          "name": "unknown.exe",
          "path": "C:\\Users\\jdoe\\AppData\\Local\\Temp\\unknown.exe",
          "cmdline": "\"C:\\Users\\jdoe\\AppData\\Local\\Temp\\unknown.exe\" --run",
          "sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
        },
        "destination": {
          "vendor": "OpenAI",
          "matched_type": "domain",
          "matched_value": "api.openai.com",
          "resolved_ip": "104.18.12.123",
          "port": 443,
          "protocol": "TCP",
          "tls_sni": "api.openai.com"
        },
        "network": {
          "direction": "outbound",
          "action": "connection_success"
        },
        "notes": [
          "No installed-app match for OpenAI/ChatGPT on this endpoint.",
          "Possible: renamed binary, portable app, embedded agent, or browser-less client."
        ]
      },
      {
        "timestamp": "2026-02-19T15:02:10Z",
        "initiating_process": {
          "name": "python.exe",
          "path": "C:\\Python311\\python.exe",
          "cmdline": "python agent.py",
          "sha256": "7b8b965ad4bca0e41ab51de7b31363a1e5c427f17431f5b89f6a1ebf7af51212"
        },
        "destination": {
          "vendor": "OpenAI",
          "matched_type": "domain",
          "matched_value": "api.openai.com",
          "resolved_ip": "104.18.14.123",
          "port": 443,
          "protocol": "TCP",
          "tls_sni": "api.openai.com"
        },
        "network": {
          "direction": "outbound",
          "action": "connection_success"
        },
        "notes": [
          "Python process initiating LLM traffic; could be internal tooling or unauthorized agent."
        ]
      }
    ],
    "vendor_inference": [
      {
        "vendor": "OpenAI",
        "confidence": 0.92,
        "reasons": [
          "domain_match: api.openai.com",
          "tls_sni_match: api.openai.com"
        ]
      }
    ],
    "risk_flags": [
      "no_app_inventory_match",
      "unknown_or_sideloaded_process"
    ],
    "recommended_actions": [
      "monitor",
      "validate_process_origin",
      "check user justification",
      "consider block_indicator (domain) if unauthorized"
    ]
  },
  {
    "device_id": "dev-net-0002",
    "device_name": "FIN-WS-0102",
    "edr_source": "crowdstrike",
    "signal_type": "network_ioc_match",
    "summary": {
      "first_seen": "2026-02-18T11:44:21Z",
      "last_seen": "2026-02-19T16:58:40Z",
      "events": 19,
      "distinct_destinations": 2
    },
    "evidence": [
      {
        "timestamp": "2026-02-19T16:58:40Z",
        "initiating_process": {
          "name": "chrome.exe",
          "path": "C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe",
          "cmdline": "\"chrome.exe\" --profile-directory=Default",
          "sha256": "9c1185a5c5e9fc54612808977ee8f548b2258d31"
        },
        "destination": {
          "vendor": "Anthropic",
          "matched_type": "domain",
          "matched_value": "claude.ai",
          "resolved_ip": "172.64.154.10",
          "port": 443,
          "protocol": "TCP",
          "tls_sni": "claude.ai"
        },
        "network": {
          "direction": "outbound",
          "action": "connection_success"
        },
        "notes": [
          "No installed-app match for Claude Desktop/Anthropic client.",
          "Browser-based use or embedded extension possible."
        ]
      }
    ],
    "vendor_inference": [
      {
        "vendor": "Anthropic",
        "confidence": 0.9,
        "reasons": [
          "domain_match: claude.ai",
          "tls_sni_match: claude.ai"
        ]
      }
    ],
    "risk_flags": [
      "no_app_inventory_match"
    ],
    "recommended_actions": [
      "monitor",
      "review browser usage policy",
      "consider SWG/CASB controls for claude.ai"
    ]
  },
  {
    "device_id": "dev-net-0003",
    "device_name": "MKT-LT-0103",
    "edr_source": "sophos",
    "signal_type": "network_ioc_match",
    "summary": {
      "first_seen": "2026-02-17T21:07:02Z",
      "last_seen": "2026-02-19T18:01:55Z",
      "events": 41,
      "distinct_destinations": 4
    },
    "evidence": [
      {
        "timestamp": "2026-02-19T18:01:55Z",
        "initiating_process": {
          "name": "electron.exe",
          "path": "C:\\Users\\asmith\\AppData\\Local\\Programs\\UnknownApp\\electron.exe",
          "cmdline": "\"electron.exe\" --enable-features=NetworkService",
          "sha256": "4a44dc15364204a80fe80e9039455cc1608281820fe2b24f1e5233ade6af1dd5"
        },
        "destination": {
          "vendor": "Perplexity AI",
          "matched_type": "domain",
          "matched_value": "api.perplexity.ai",
          "resolved_ip": "151.101.1.140",
          "port": 443,
          "protocol": "TCP",
          "tls_sni": "api.perplexity.ai"
        },
        "network": {
          "direction": "outbound",
          "action": "connection_success"
        },
        "notes": [
          "Electron app not matched in software inventory.",
          "Could be a repackaged client or unauthorized wrapper."
        ]
      }
    ],
    "vendor_inference": [
      {
        "vendor": "Perplexity AI",
        "confidence": 0.91,
        "reasons": [
          "domain_match: api.perplexity.ai",
          "tls_sni_match: api.perplexity.ai"
        ]
      }
    ],
    "risk_flags": [
      "no_app_inventory_match",
      "unknown_or_sideloaded_process"
    ],
    "recommended_actions": [
      "monitor",
      "hunt for UnknownApp install source",
      "consider block_indicator (domain) if unapproved"
    ]
  },
]

export default function AisprawlScan() {
  const [showScanModal, setShowScanModal] = useState(false);
  const [progress, setProgress] = useState(0); // 0–100 overall
  const sampleAppEndpoints = APP_ENDPOINTS.slice(0, 3);
  const TOTAL_MS = 30000; // 30s overall scan duration

  // Simulate scan progression with a timer
  useEffect(() => {
    if (!showScanModal) {
      setProgress(0);
      return;
    }

    const start = Date.now();
    setProgress(0);

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, (elapsed / TOTAL_MS) * 100);
      setProgress(pct);
      if (elapsed >= TOTAL_MS) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [showScanModal]);

  // Phase mapping over 30s:
  // 0–2.5s   (0–8.33%)   : line into Apps animates (quick)
  // 2.5–17.5s (8.33–58.33%): Apps circle throbs (15s)
  // 17.5–20s (58.33–66.67%): line between Apps and IPs animates (quick, 2.5s)
  // 20–30s  (66.67–100%): IPs circle throbs (10s)
  const P_LINE1_END = 8.33;
  const P_APPS_END = 58.33;
  const P_LINE2_END = 66.67;

  const appEndpoints = sampleAppEndpoints;
  const ipEndpoints = IP_ENDPOINTS;

  // Circle state flags
  const appsScanning = progress >= P_LINE1_END && progress < P_APPS_END;
  const appsDone = progress >= P_APPS_END;
  const ipsScanning = progress >= P_LINE2_END && progress < 100;
  const ipsDone = progress >= 100;

  const inIpPhase = progress >= P_LINE2_END;

  // Apps phase: spread 3 endpoints once across the Apps window, no looping
  let appEndpointIdx = 0;
  if (appEndpoints.length) {
    if (progress <= P_LINE1_END) {
      appEndpointIdx = 0;
    } else if (progress < P_APPS_END) {
      const phaseSpan = P_APPS_END - P_LINE1_END;
      const phaseProgress = Math.min(
        0.999,
        Math.max(0, (progress - P_LINE1_END) / phaseSpan)
      );
      appEndpointIdx = Math.min(
        appEndpoints.length - 1,
        Math.floor(phaseProgress * appEndpoints.length)
      );
    } else {
      appEndpointIdx = Math.min(appEndpoints.length - 1, 2);
    }
  }

  // IP phase: spread 3 endpoints once across the IP window, no looping
  let ipEndpointIdx = 0;
  if (ipEndpoints.length) {
    if (progress < P_LINE2_END) {
      ipEndpointIdx = 0;
    } else {
      const phaseSpanIp = 100 - P_LINE2_END;
      const phaseProgressIp = Math.min(
        0.999,
        Math.max(0, (progress - P_LINE2_END) / phaseSpanIp)
      );
      ipEndpointIdx = Math.min(
        ipEndpoints.length - 1,
        Math.floor(phaseProgressIp * ipEndpoints.length)
      );
    }
  }

  const currentEndpoint = inIpPhase
    ? ipEndpoints[ipEndpointIdx]
    : appEndpoints[appEndpointIdx];

  const scannedAppEndpoints =
    progress <= P_LINE1_END
      ? 0
      : progress < P_APPS_END
        ? appEndpointIdx + 1
        : appEndpoints.length;

  const totalScanned =
    progress <= P_LINE1_END
      ? 0
      : progress < P_APPS_END
        ? appEndpointIdx + 1
        : progress < P_LINE2_END
          ? 3
          : Math.min(6, 3 + ipEndpointIdx + 1);

  const detectedAiEndpoints = totalScanned; // demo: treat all scanned endpoints as AI endpoints
  const detectedAiApps = appEndpoints
    .slice(0, scannedAppEndpoints)
    .reduce((sum, endpoint) => sum + (endpoint.apps?.length ?? 0), 0);
  const detectedAiFromIps = progress < P_LINE2_END ? 0 : Math.min(3, ipEndpointIdx + 1);

  const line1Active = progress >= P_LINE1_END;
  const line2Active = progress >= P_APPS_END;

  return (
    <>
      <div className="dashboard-header-row d-flex flex-row flex-nowrap align-items-center mb-4 w-100">
        <h1 className="dashboard-title mb-0 flex-shrink-0">Scan</h1>
      </div>

      <div className="aisprawl-scan-cta-wrap">
        <button
          type="button"
          className="btn btn-primary btn-lg aisprawl-scan-cta-btn"
          onClick={() => setShowScanModal(true)}
        >
          Run Scan
        </button>
      </div>

      {showScanModal && (
        <div className="pm-modal-overlay">
          <div className="pm-modal aisprawl-scan-modal">
            <h2 className="pm-modal-title">Running Scan</h2>

            {/* Top section: circles + progress bar */}
            <div className="aisprawl-scan-top">
              <div className="aisprawl-scan-circles">
                <div
                  className={
                    "aisprawl-scan-line" +
                    (line1Active ? " aisprawl-scan-line--active" : "")
                  }
                />
                <div className="aisprawl-scan-circle">
                  <div
                    className={
                      "aisprawl-scan-circle-visual" +
                      (appsScanning
                        ? " aisprawl-scan-circle-visual--scanning"
                        : appsDone
                          ? " aisprawl-scan-circle-visual--done"
                          : "")
                    }
                  >
                    <FaThLarge className="aisprawl-scan-circle-icon" />
                  </div>
                  <div className="aisprawl-scan-circle-label">Apps</div>
                </div>
                <div
                  className={
                    "aisprawl-scan-line" +
                    (line2Active ? " aisprawl-scan-line--active" : "")
                  }
                />
                <div className="aisprawl-scan-circle">
                  <div
                    className={
                      "aisprawl-scan-circle-visual" +
                      (ipsScanning
                        ? " aisprawl-scan-circle-visual--scanning"
                        : ipsDone
                          ? " aisprawl-scan-circle-visual--done"
                          : "")
                    }
                  >
                    <FaGlobe className="aisprawl-scan-circle-icon" />
                  </div>
                  <div className="aisprawl-scan-circle-label">IPs</div>
                </div>
              </div>

              <div className="aisprawl-scan-progress">
                <div className="aisprawl-scan-progress-bar">
                  <div
                    className="aisprawl-scan-progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <div className="aisprawl-scan-progress-text">
                  {Math.round(progress)}% complete
                </div>
              </div>

            </div>

            <div className="aisprawl-scan-bottom-row">
              <div className="aisprawl-scan-summary">
                <div className="aisprawl-scan-summary-title">Scan Progress</div>
                <div className="aisprawl-scan-summary-row">
                  <span className="aisprawl-scan-summary-label">
                    Current Endpoint
                  </span>
                  <span className="aisprawl-scan-summary-value">
                    {currentEndpoint?.device_name ?? "<>"}
                  </span>
                </div>
                {!inIpPhase && (
                  <>
                    <div className="aisprawl-scan-summary-row">
                      <span className="aisprawl-scan-summary-label">
                        Apps Found
                      </span>
                      <span className="aisprawl-scan-summary-value" />
                    </div>
                    <div className="aisprawl-scan-apps-list">
                      <ul className="aisprawl-scan-apps-endpoint-apps">
                        {(currentEndpoint?.apps ?? []).map((app, idx) => (
                          <li
                            key={`apps-${currentEndpoint?.device_id ?? "endpoint"}-${app.app}-${idx}`}
                            className="aisprawl-scan-apps-endpoint-app"
                          >
                            {app.app}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
              <div className="aisprawl-scan-summary aisprawl-scan-summary--stats">
                <div className="aisprawl-scan-summary-title">Full Statistics</div>
                <div className="aisprawl-scan-summary-row">
                  <span className="aisprawl-scan-summary-label">Total Scanned</span>
                  <span className="aisprawl-scan-summary-value">{totalScanned}</span>
                </div>
                <div className="aisprawl-scan-summary-row">
                  <span className="aisprawl-scan-summary-label">
                    Detected AI Endpoints
                  </span>
                  <span className="aisprawl-scan-summary-value">{detectedAiEndpoints}</span>
                </div>
                <div className="aisprawl-scan-summary-row">
                  <span className="aisprawl-scan-summary-label">
                    Detected AI Apps
                  </span>
                  <span className="aisprawl-scan-summary-value">{detectedAiApps}</span>
                </div>
                <div className="aisprawl-scan-summary-row">
                  <span className="aisprawl-scan-summary-label">
                    Detected AI from IPs
                  </span>
                  <span className="aisprawl-scan-summary-value">{detectedAiFromIps}</span>
                </div>
              </div>
            </div>

            <div className="pm-modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowScanModal(false)}
              >
                {progress >= 100 ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
